document.addEventListener('DOMContentLoaded', () => {
    initDescriptionReadMore();
    initMediaGalleryShowMore();
    initMenuMinHeight();
});


function initMenuMinHeight() {
    const menu = document.querySelector('.main-menu');
    if (!menu) return;

    menu.querySelectorAll('ul.level-1 > li').forEach(li => {
        li.addEventListener('mouseenter', () => {
            const level1 = li.closest('ul.level-1');
            const level2 = li.querySelector(':scope > ul.level-2');

            if (!level1 || !level2) return;
            level2.style.minHeight = level1.getBoundingClientRect().height + 'px';
        });
    });
}

function initDescriptionReadMore() {
    const description = document.querySelector('.product-details rte-formatter');
    if (!description) return;

    const paragraphs = description.querySelectorAll('p');

    if (paragraphs.length > 2) {
        const readMoreButton = document.createElement('button');
        readMoreButton.type = 'button';
        readMoreButton.innerText = 'Lees meer';
        readMoreButton.classList.add('description__read-more-button');
        readMoreButton.dataset.switchText = 'Lees minder';

        readMoreButton.addEventListener('click', () => {
            description.classList.toggle('show-more');

            const newText = readMoreButton.dataset.switchText;

            readMoreButton.dataset.switchText = readMoreButton.innerText;
            readMoreButton.innerText = newText;
        });

        const readMoreButtonContainer = document.createElement('span');
        readMoreButtonContainer.append(readMoreButton);

        description.append(readMoreButtonContainer);
    }
}

function initMediaGalleryShowMore() {
    const mediaGallery = document.querySelector('media-gallery');
    const mediaGalleryGrid = document.querySelector('.media-gallery__grid');
    const mediaGalleryItems = document.querySelectorAll('.media-gallery__grid li');

    if (mediaGalleryItems.length > 4) {
        const showMoreButton = document.createElement('button');
        showMoreButton.type = 'button';
        showMoreButton.innerText = 'Toon meer';
        showMoreButton.classList.add('media-gallery__show-more-button');
        showMoreButton.dataset.switchText = 'Toon minder';

        showMoreButton.addEventListener('click', () => {
            mediaGalleryGrid.classList.toggle('show-more');

            const newText = showMoreButton.dataset.switchText;

            showMoreButton.dataset.switchText = showMoreButton.innerText;
            showMoreButton.innerText = newText;
        });

        mediaGallery.append(showMoreButton);
    }
}